export default function BrandMark({ size = 20, className = "" }) {
  return (
    <svg
      data-testid="brand-mark"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
        d="M24 8h16M27 8v17L12 49a5 5 0 0 0 4 7h32a5 5 0 0 0 4-7L37 25V8M20 41h24"
      />
      <circle cx="28" cy="46" r="3" fill="currentColor" />
      <circle cx="38" cy="49" r="2" fill="currentColor" />
    </svg>
  );
}
